const KeyboardControls = () => {
  const isSpacebar = (event) => event.key === ' '

  const isShift = (event) => event.shiftKey || event.key === 'Shift'

  const isBackspace = (event) => event.key === 'Backspace'

  const isDelete = (event) => event.key === 'Delete'

  const isEscape = (event) => event.key === 'Escape'

  const isAlt = (event) => event.altKey || event.key === 'Alt'

  const isMetaKey = (event) => event.metaKey || event.ctrlKey || event.key === 'Meta' || event.key === 'Control'

  const isUndo = (event) => isMetaKey(event) && event.key === 'z'

  const isRedo = (event) => isMetaKey(event) && event.key === 'y'

  const isSave = (event) => isMetaKey(event) && event.key === 's'

  const isWheel = (event) => event.type === 'wheel'

  // ...

  return {
    isSpacebar,
    isShift,
    isBackspace,
    isDelete,
    isEscape,
    isAlt,
    isMetaKey,
    isUndo,
    isRedo,
    isSave,
    isWheel,
    // ...
  }
}

export default KeyboardControls()
